<template>
  <div class="faq-bloc">
    <div class="faq-bloc-header">
      <h2>{{$resx('FaqPoolsInformationsText')}}</h2>
    </div>
    <div v-if="!isSaving" class="faq-bloc-body">
      <div class="row">
        <div class="col col-25">
          {{$resx('FaqPoolsNumberText')}}
        </div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.nbPools===null">?</span>
          <span v-if="!editMode && modelCopy.nbPools!==null">{{modelCopy.nbPools}}</span>
          <input v-if="editMode" type="number" v-model.number="modelCopy.nbPools" min="0" max="20" name="nbPools" v-validate="'between:0,20'" :class="{'field-validation-error': errors.has('nbPools')}"/>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">{{$resx('FaqPoolsOpeningDateText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.openingDate===null">?</span>
          <span v-if="!editMode && modelCopy.openingDate!==null">{{getFormatedDate(modelCopy.openingDate)}}</span>
          <input v-if="editMode"  type="date" v-model="modelCopy.inputOpeningDate" ref="openingDate"  name="openingDate" :min="dateMin" :max="dateMax" v-validate="'date_format:yyyy-mm-dd'" :class="{'field-validation-error': errors.has('openingDate')}"/>
        </div>
        <div class="col col-25">{{$resx('FaqPoolsClosingDateText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.closingDate===null">?</span>
          <span v-if="!editMode && modelCopy.closingDate!==null">{{getFormatedDate(modelCopy.closingDate)}}</span>
          <input v-if="editMode" type="date" v-model="modelCopy.inputClosingDate" name="closingDate" :min="dateMin" :max="dateMax" v-validate="'date_format:yyyy-mm-dd|isDateBigger:openingDate'" :class="{'field-validation-error': errors.has('closingDate')}"/>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">{{$resx('FaqPoolsOpeningTimeText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.openingTime===null">?</span>
          <span v-if="!editMode && modelCopy.openingTime!==null">{{getFormatedTime(modelCopy.openingTime)}}</span>
          <input v-if="editMode" type="time" v-model="modelCopy.inputOpeningTime" ref="openingTime"  name="openingTime" :class="{'field-validation-error': errors.has('openingTime')}"/>
        </div>
        <div class="col col-25">{{$resx('FaqPoolsClosingTimeText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.closingTime===null">?</span>
          <span v-if="!editMode && modelCopy.closingTime!==null">{{getFormatedTime(modelCopy.closingTime)}}</span>
          <input v-if="editMode" type="time" v-model="modelCopy.inputClosingTime" name="closingTime" v-validate="'isDateBigger:openingTime'" :class="{'field-validation-error': errors.has('closingTime')}"/>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">{{$resx('FaqPoolsHeatedText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.heated===null">?</span>
          <i v-if="!editMode && modelCopy.heated!==null" class='material-icons'>{{getCheckStateClass(modelCopy.heated)}}</i>
          <select v-if="editMode" v-model="modelCopy.heated">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
        <div class="col col-25">{{$resx('FaqPoolsIndoorText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.indoor===null">?</span>
          <i v-if="!editMode && modelCopy.indoor!==null" class='material-icons'>{{getCheckStateClass(modelCopy.indoor)}}</i>
          <select v-if="editMode" v-model="modelCopy.indoor">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">{{$resx('FaqPoolsWaterSlidesText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.waterSlides===null">?</span>
          <i v-if="!editMode && modelCopy.waterSlides!==null" class='material-icons'>{{getCheckStateClass(modelCopy.waterSlides)}}</i>
          <select v-if="editMode" v-model="modelCopy.waterSlides">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
        <div class="col col-25">{{$resx('FaqPoolsPaddlingText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.paddling===null">?</span>
          <i v-if="!editMode && modelCopy.paddling!==null" class='material-icons'>{{getCheckStateClass(modelCopy.paddling)}}</i>
          <select v-if="editMode" v-model="modelCopy.paddling">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">{{$resx('FaqPoolsSupervisedText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.supervised===null">?</span>
          <i v-if="!editMode && modelCopy.supervised!==null" class='material-icons'>{{getCheckStateClass(modelCopy.supervised)}}</i>
          <select v-if="editMode" v-model="modelCopy.supervised">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
        <div class="col col-25">{{$resx('FaqPoolsShortAllowedText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.shortAllowed===null">?</span>
          <i v-if="!editMode && modelCopy.shortAllowed!==null" class='material-icons'>{{getCheckStateClass(modelCopy.shortAllowed)}}</i>
          <select v-if="editMode" v-model="modelCopy.shortAllowed">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
      </div>
    </div>
    <div v-else class="faq-bloc-body text-center">
      <i class="loading material-icons">cached</i>
    </div>
    <div class="faq-bloc-footer">
      <button v-show="!editMode" class="btn btn-secondary" @click="editMode=true">{{$resx('EditText')}}</button>
      <button v-show="editMode" class="btn btn-secondary" @click="editMode=false">{{$resx('CancelText')}}</button>
      <button v-show="editMode" style="margin-left:.5em" class="btn btn-primary" @click="save" :disabled="isSaving" >{{$resx('SaveText')}}</button>
    </div>
  </div>
</template>
<script>
import faqServices from '../../services/faqServices'
import FaqPools from '../../models/faq/faqPools'
import helperServices from '../../services/helperServices'
var moment = require('moment')

export default {
  props: {
    pools: null
  },
  data () {
    return {
      isSaving: false,
      editMode: false,
      modelCopy: null,
      dateMin: null,
      dateMax: null
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }

  },
  watch: {
    editMode: function (val) {
      this.modelCopy = this.copyFullObject(this.pools)
    }
  },
  methods:
  {
    // Copie de l'objet référence dans une autre variable
    copyFullObject: function (source) {
      let newObj = {}
      if (source !== null) {
        newObj = new FaqPools(source)
      }
      return newObj
    },

    // retourne l'icone pour indiquer le statut d'un item
    getCheckStateClass: function (value) {
      if (value === null) {
        return 'fa-question'
      } else {
        return value ? 'check' : 'close'
      }
    },

    // sauvegarde des infos
    save: function () {
      const self = this
      self.isSaving = true

      // copie des dates et heure
      this.modelCopy.openingDate = helperServices.getDateFromInput(this.modelCopy.inputOpeningDate)
      this.modelCopy.closingDate = helperServices.getDateFromInput(this.modelCopy.inputClosingDate)
      this.modelCopy.openingTime = helperServices.getTimeFromInput(this.modelCopy.inputOpeningTime)
      this.modelCopy.closingTime = helperServices.getTimeFromInput(this.modelCopy.inputClosingTime)

      faqServices.saveFaqPools(this.currentCampingId, this.modelCopy)
        .then(response => {
          // signaler l'update au parent
          self.$emit('update-items', this.copyFullObject(this.modelCopy))
          self.isSaving = false
          self.editMode = false
          const message = self.$resx('FaqSavedText')
          self.$store.commit('app/showSnack', { type: 'success', message: message })
        })
        .catch(error => {
          self.isSaving = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },

    // Retourne une date formatée pour le user
    getFormatedDate (jsonDate) {
      return helperServices.getFormatedDate(jsonDate)
    },

    // Retourne une heure formatée pour le user
    getFormatedTime (jsonTime) {
      return helperServices.getFormatedTime(jsonTime)
    }
  },
  created: function () {
    this.modelCopy = this.copyFullObject(this.pools)
    this.dateMin = moment().format('YYYY-01-01')
    this.dateMax = moment().add(1, 'year').format('YYYY-12-31')
  }
}
</script>
